import type { CreatePurchaseOrderDocumentLinkArgs, DocumentLinkCreated } from '@ztechapps/common.contract'
import { useActionMutation } from '@ztechapps/common.hook'
import { createPurchaseOrderDocumentLinkQuery } from './graphql'

export type UseCreatePurchaseOrderDocumentLinkResult = {
  /** Creates a new public link for the purchase order; the token is shown only in this result. */
  mint: (purchaseOrderId: string) => Promise<DocumentLinkCreated>
}

export const useCreatePurchaseOrderDocumentLink = (): UseCreatePurchaseOrderDocumentLinkResult => {
  const [createLink] = useActionMutation<DocumentLinkCreated, CreatePurchaseOrderDocumentLinkArgs>({
    query: createPurchaseOrderDocumentLinkQuery,
  })

  return { mint: (purchaseOrderId) => createLink({ purchaseOrderId }) }
}
